import {get} from 'lodash-es';
import {type Get} from 'type-fest';
import psrLabels from '../resources/labels/psrLabels.js';

type NestedKeyOfArray<T extends readonly any[]> = {
  [K in keyof T]: T[K] extends readonly any[]
    ? `[${K}]${NestedKeyOf<T[K]>}` | `[${K}]`
    : T[K] extends Record<string, unknown>
      ? `[${K}].${NestedKeyOf<T[K]>}` | `[${K}]`
      : `[${K}]`;
}[number];

type NestedKeyOf<T extends Record<string, unknown>> = {
  [K in keyof T & (number | string)]: T[K] extends readonly any[]
    ? `${K}${NestedKeyOfArray<T[K]>}` | `${K}`
    : T[K] extends Record<string, unknown>
      ? `${K}.${NestedKeyOf<T[K]>}` | `${K}`
      : `${K}`;
}[keyof T & (number | string)];

const getPsrLabel = <
  Path extends NestedKeyOf<typeof psrLabels>,
  Label extends Get<typeof psrLabels, Path>,
  Result extends Label extends (...args: any[]) => any
    ? ReturnType<Label>
    : Label,
>(
  path: Path,
  ...data: Label extends (...args: infer P) => any ? P : []
): Result => {
  const label = get(psrLabels, path, path) as Label;

  if (typeof label === 'function') {
    // we have to use the ts-ignore directive here to make this method generic and working in app
    // where labels have no key of type function
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return label(...data);
  }

  return label as unknown as Result;
};

export default getPsrLabel;
